import { Box, useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import EventForm from '../../components/events/components/EventForm';
import { addEvents } from '../../components/events/api/addEvents';
import { eventSchema } from './schema';

function NewEvent() {
    const toast = useToast();
    const navigate = useNavigate();

    const handleSuccess = () => {
        toast({
            title: "Event created",
            description: "Event created successfully",
            status: "success",
            duration: 5000,
            isClosable: true,
        });
        navigate("/events");
    };

    const handleError = (error: any) => {
        toast({
            title: "Event Creation Failed",
            description: error.message || "Event creation failed",
            status: "error",
            duration: 5000,
            isClosable: true,
        });
    };

    return (
        <Box>
            <EventForm
                initialValues={{
                    name: '',
                    location: '',
                    event_status: '',
                    event_date: '',
                    capacity: 0,
                    description: ""
                }}
                onConfirm={addEvents}
                onSuccess={handleSuccess}
                onError={handleError}
                title="Add Event"
                schema={eventSchema}
            />
        </Box>
    );
}

export default NewEvent;